<template>
  <div class="demand-card">
    <div class="card-header">
      <div class="header-left">
        <h3 class="demand-title">{{ demand.title }}</h3>
        <span class="demand-category" v-if="demand.category">{{ demand.category }}</span>
      </div>
      <span class="demand-type" v-if="demand.type">{{ demand.type }}</span>
    </div>

    <div class="card-image" v-if="demand.image">
      <img :src="demand.image" :alt="demand.title" />
    </div>

    <div class="card-content">
      <p class="demand-description">{{ demand.description }}</p>

      <div class="demand-info">
        <div class="info-item">
          <span class="label">发布方：</span>
          <span class="value">{{ demand.publisher }}</span>
        </div>
        <div class="info-item" v-if="demand.price !== undefined && demand.price !== null">
          <span class="label">价格：</span>
          <span class="value price">¥{{ formatPrice(demand.price) }}</span>
        </div>
        <div class="info-item" v-if="demand.createTime">
          <span class="label">发布时间：</span>
          <span class="value">{{ formatTime(demand.createTime) }}</span>
        </div>
      </div>

      <div class="demand-tags">
        <span
          v-for="(tag, index) in demand.tags"
          :key="index"
          class="tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>

    <div class="card-actions">
      <button class="btn-contact" @click="handleContact">
        对接需求
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DemandCard',
  props: {
    demand: {
      type: Object,
      default: () => ({
        id: 0,
        title: '',
        description: '',
        tags: [],
        category: '',
        contact: '',
        publisher: '',
        status: '进行中',
        price: null,
        type: '',
        image: '',
        createTime: ''
      })
    }
  },
  methods: {
    handleContact() {
      this.$emit('contact', this.demand)
    },
    formatPrice(price) {
      if (price === null || price === undefined) return '-'
      return price.toLocaleString('zh-CN')
    },
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      return date.toLocaleDateString('zh-CN')
    }
  }
}
</script>

<style scoped>
.demand-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 16px;
}

.demand-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 8px 16px;
}

.header-left {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.demand-title {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.demand-category {
  background: #42b983;
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  display: inline-block;
  width: fit-content;
}

.demand-type {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.card-image {
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  padding: 8px 16px 12px 16px;
}

.demand-description {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.demand-info {
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  margin-bottom: 4px;
  font-size: 12px;
}

.label {
  color: #999;
  margin-right: 6px;
  white-space: nowrap;
}

.value {
  color: #333;
  font-weight: 500;
}

.value.price {
  color: #ff6b6b;
  font-weight: 600;
}

.demand-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.tag {
  background: #f0f9ff;
  color: #007bff;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.card-actions {
  padding: 8px 16px;
  border-top: 1px solid #eee;
}

.btn-contact {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  border: none;
  padding: 8px 24px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.btn-contact:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(42, 82, 152, 0.3);
}

@media (max-width: 768px) {
  .demand-card {
    margin-bottom: 10px;
  }

  .card-header {
    padding: 10px 12px 6px 12px;
  }

  .demand-title {
    font-size: 15px;
  }

  .card-image {
    height: 80px;
  }

  .card-content {
    padding: 6px 12px 10px 12px;
  }

  .card-actions {
    padding: 6px 12px;
  }

  .btn-contact {
    padding: 6px 20px;
    font-size: 12px;
  }

  .card-content {
    padding: 10px 16px 16px 16px;
  }

  .btn-contact {
    padding: 8px 24px;
    font-size: 13px;
  }
}
</style>
